// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-users-wrap .part-box {\n  border: none;\n}\n.select-users-wrap .table-box {\n  border: 1px solid #e4e4e4;\n  border-left: 0;\n}\n.select-users-wrap .custom-card {\n  height: 100%;\n}\n.select-users-wrap .custom-card .el-card__body {\n    height: calc(100% - 34px);\n    overflow: auto;\n}\n.select-users-wrap .flex-item {\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
